import styled from 'styled-components'

export const PopUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const PopUpHeader = styled.div`
  background-color: #0066B3;
  height: 53px;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
  flex-shrink: 0;
`

export const PopUpTitle = styled.h4`
  color: #fff;
  font-size: 20px;
  margin: 0;

  @media (max-width: 575px) {
    font-size: 16px;
  }
`

export const PopUpContent = styled.div`
  min-height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 24px 32px 0;

  @media (max-width: 575px) {
    height: auto;
    padding: 20px 24px 0;
  }
`

export const PopUpParagraph = styled.span`
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  color: #464646;
  width: 100%;
  text-align: center;
  display: block;
  overflow: visible;
  line-height: 1.6;
`
